// @ngInject
function BrandsApiService($q, DS, DSHttpAdapter, ResourcesService) {

    var endpoint = 'brands';

    return {
        getBrands: ResourcesService.apiFactory.get(endpoint),
        getBrand: ResourcesService.apiFactory.get(endpoint),
        createBrand: createBrand,
        updateBrand: updateBrand,
        getTenantConfig: ResourcesService.apiFactory.get(endpoint + '/tenantconfig'),
        getMainGroups: ResourcesService.apiFactory.get(endpoint + '/maingroups'),
        getCompanies: ResourcesService.apiFactory.get(endpoint + '/companies'),
        getBrandCategories: ResourcesService.apiFactory.get(endpoint + '/brandcategories'),
        getSalesChannels: ResourcesService.apiFactory.get(endpoint + '/saleschannels'),
        getVariantGroups: ResourcesService.apiFactory.get(endpoint + '/variantgroups'),
        getBarcodeTypes: ResourcesService.apiFactory.get(endpoint + '/barcodetypes'),
        createItemGroups: createItemGroups,
        connectBrandSupplier: connectBrandSupplier,
        disconnectBrandSupplier: disconnectBrandSupplier
    };

    function createBrand(brand, mainGroups, addedCompanies, removedCompanies) {

        var args = {
            brand: brand,
            mainGroups: mainGroups,
            addedCompanies: addedCompanies,
            removedCompanies: removedCompanies
        };

        return ResourcesService.apiFactory.create(endpoint,'Brand')(args);

    }

    function updateBrand(brand, mainGroups, addedCompanies, removedCompanies) {

        var args = {
            brand: brand,
            mainGroups: mainGroups,
            addedCompanies: addedCompanies,
            removedCompanies: removedCompanies
        };

        return ResourcesService.apiFactory.update(endpoint,'Brand')(args);
    }

    function connectBrandSupplier(brandId, supplierTenant, locationIds) {
        var deferred = $q.defer();

        DSHttpAdapter.POST(DS.defaults.basePath + endpoint + '/' + brandId + '/brandconnect/supplier', {
            supplierTenant: supplierTenant,
            locationIds: locationIds
        }).then(function (response) {
            deferred.resolve(response.data);
        }, function (error) {
            deferred.reject(ResourcesService.handleResourceError(error));
        });

        return deferred.promise;
    }

    function disconnectBrandSupplier(brandId) {
        var deferred = $q.defer();

        DSHttpAdapter.DEL(DS.defaults.basePath + endpoint + '/' + brandId + '/brandconnect/supplier').then(function (response) {
            deferred.resolve(response.data);
        }, function (error) {
            deferred.reject(ResourcesService.handleResourceError(error));
        });

        return deferred.promise;
    }

    function createItemGroups(mainGroups, brands) {

        var args = {
            mainGroups: mainGroups,
            brands: brands
        };

        return ResourcesService.apiFactory.update(endpoint + '/createitemgroups','MainGroup')(args);
    }

}


angular.module('brands.api', [])
  .factory('BrandsApiService', BrandsApiService);
